
            const data = {"name":"icon-plus-medium","data":{"width":"32","height":"32","viewBox":"0 0 32 32","data":"<path pid=\"0\" _fill=\"currentColor\" d=\"M1.8 17a1 1 0 010-2h28.4a1 1 0 010 2H1.8z\"/><path pid=\"1\" _fill=\"currentColor\" d=\"M17 30.2a1 1 0 01-2 0V1.8a1 1 0 012 0v28.4z\"/>"}}
        
                module.exports = data
                